module.exports = __webpack_public_path__ + "img/Martinique.d7b33aeb.svg";